export default "__VITE_ASSET__4473526f__"